import flowRight from 'lodash/flowRight';

import addOverlayControls from 'eventbrite_design_system/structure/hoc/addOverlayControls';
import addMainControls from 'eventbrite_design_system/structure/hoc/addMainControls';
import addFocusDrawerControls from 'eventbrite_design_system/structure/hoc/addFocusDrawerControls';

/**
 * Enhances a component (typically `SiteStructure`) with useful HOC controls.
 * Also useful for enhancing mock components in unit tests.
 * @param {import('react').Component} component The component to enhance
 * @returns {import('react').Component} Enhanced component
 */
export const enhance = flowRight(
    addOverlayControls,
    addMainControls,
    addFocusDrawerControls,
);
